/**************************************************
 * Nombre:       Tarjeta_Vista_Producto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {useNavigate} from "react-router";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {useContext, useEffect, useState} from "react";
import {contexApp} from "../../App";
import {valorConDescuento} from "../../CodCliente/valorConDescuento";

const Tarjeta_Vista_Producto = ({item, productos = []}) => {
    const navigate = useNavigate()
    const cData = useContext(contexApp)
    const {sCell} = useResponsive()
    const [esBlack, setEsBlack] = useState(false)


    useEffect(() => {

        if (cData.configuraciones?.black === 'Si') {
            setEsBlack(true)
        } else {
            setEsBlack(false)
        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-end'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                height: 540,
                width: '100%',
                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0.00) 49.67%, #000 100%), url(${item})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                px: 3,
                py: 4
            }}
        >


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  spacing={1}
            >

                {productos.map((it, index) => {
                    return (
                        <Grid container size={{xs: 6, sm: 6, md: 6}}>
                            <Grid
                                onClick={() => navigate('/Detalle/' + it.id)}
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{
                                    color: '#fff',
                                    border: 1,
                                    borderColor: '#ffffff00',
                                    cursor: 'pointer',
                                    '&:hover': {
                                        borderColor: '#fff',
                                        backgroundColor: '#ffffff20'
                                    },
                                    p: 1
                                }}
                                spacing={0}
                            >

                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Typography sx={{fontWeight: 600}}>{it.nombre}</Typography>
                                </Grid>


                                <Grid container size={{xs: 12, sm: 12, md: 12}}>

                                    {esBlack ?

                                        <Typography
                                            sx={{
                                                fontSize: 14,
                                                borderBottom: 1,
                                                borderColor: '#fff'
                                            }}>{formatoMoneda(valorConDescuento({
                                            valor: it.valor,
                                            descuento: 20
                                        }))}</Typography>

                                        :

                                        <Typography
                                            sx={{
                                                fontSize: 14,
                                                borderBottom: 1,
                                                borderColor: '#fff'
                                            }}>{formatoMoneda(it.valor)}</Typography>

                                    }
                                </Grid>


                            </Grid>
                        </Grid>
                    )
                })}
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Vista_Producto
